import { render, staticRenderFns } from "./Rubrica.vue?vue&type=template&id=4402908e&"
import script from "./Rubrica.vue?vue&type=script&lang=js&"
export * from "./Rubrica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports